import { render, staticRenderFns } from "./vipPage.vue?vue&type=template&id=7cd6db90&"
import script from "./vipPage.vue?vue&type=script&lang=ts&"
export * from "./vipPage.vue?vue&type=script&lang=ts&"
import style0 from "./vipPage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports